export enum Role {
    parent = 'parent',
    enfant = 'enfant',
    professeur = 'professeur',
}
